import { useEffect, useState } from "react";
import { getImageUsageByMediaId } from "../services/articles.service";
import { type ImageUsageEntry } from "../types/imageUsage";

/**
 * Hook that checks if a media has any dependent image usage.
 */
export const useCheckImageUsage = (
  mediaId: string | undefined
): { hasImageUsage: boolean; impactedImages: ImageUsageEntry[] } => {
  const [hasImageUsage, setHasImageUsage] = useState(false);
  const [impactedImages, setImpactedImages] = useState<ImageUsageEntry[]>([]);

  useEffect(() => {
    const checkUsageByMediaId = async () => {
      if (!mediaId) {
        setHasImageUsage(false);
        setImpactedImages([]);
        return;
      }

      try {
        const response = await getImageUsageByMediaId(mediaId);
        const imagesWithDeletedItems = response?.imagesWithDeletedItems ?? [];
        setImpactedImages(imagesWithDeletedItems);
        setHasImageUsage(
          !!response?.containsDeletedItems ||
            (!!response?.dependentImages && response.dependentImages.length > 0)
        );
      } catch (error) {
        console.error("Error checking image usage:", error);
        setHasImageUsage(false);
        setImpactedImages([]);
      }
    };

    checkUsageByMediaId();
  }, [mediaId]);

  return { hasImageUsage, impactedImages };
};
